import styled from '@emotion/styled';

export const LogoWrapper = styled.div`
  padding: 32px 8px 0;
`;
